import { render, staticRenderFns } from "./ButtonIcon.vue?vue&type=template&id=aa9c0780&"
import script from "./ButtonIcon.vue?vue&type=script&lang=js&"
export * from "./ButtonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports